import { Component} from '@angular/core'; 
import { HttpClient} from '@angular/common/http'; 
import { environment } from '.../../environments/environment'; 
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter'; 

import { AuthService } from '../../_services';




import { LoaderService } from '../../_services/loader.service';

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';


const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.zone === x.zone) === idx); 
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ward === x.ward) === idx); 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'complain-DashBoard',
  templateUrl: './targetDashboard.component.html', 
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ], 
}) 


export class TargetDashBoardComponent {  
  categoryData:any
  zoneData:any;
  zoneDataCounts:any
  targetDataCurrent:any
  targetDataPrev:any
  prjId:any;
  targetDataArray:any;
  targetCategory:any;
  targetDataArrayPrev:any
  targetDataArrayCurrent:any;
  month:any
  year:any
  type:any;
  monthArray:any
  monthName:any
  acheivedDataArrayCurrent:any
  acheivedDataCurrent:any
  showLoader:any;
  totalHHCount:any;
  precentage:any;
  totalCurrentMonthTargt:any;
  constructor(private http : HttpClient ,private auth : AuthService,private loaderService: LoaderService) { 
    // this.targetData = [
    //   {title:"KCC (Rs)",data:[{title:"KCC (Rs)",entityName:"Zone -1",count:677777},{title:"KCC (Rs)",entityName:"Zone -2",count:677},{title:"KCC (Rs)",entityName:"Zone -3",count:67},{title:"KCC (Rs)",entityName:"Zone -5",count:667}]},
    //   {title:"UCC (Rs)",data:[{title:"UCC (Rs)",entityName:"Zone -1",count:67},{title:"UCC (Rs)",entityName:"Zone -2",count:677},{title:"UCC (Rs)",entityName:"Zone -3",count:67},{title:"UCC (Rs)",entityName:"Zone -5",count:667}]},
    //   {title:"Tonnage",data:[{title:"Tonnage ",entityName:"Zone -1",count:67},{title:"Tonnage",entityName:"Zone -2",count:677},{title:"Tonnage",entityName:"Zone -3",count:67},{title:"Tonnage",entityName:"Zone -5",count:667}]},
    //   {title:"Vechicle Dispatch",data:[{title:"Vechicle Dispatch ",entityName:"Zone -1",count:67},{title:"Vechicle Dispatch",entityName:"Zone -2",count:677},{title:"Vechicle Dispatch",entityName:"Zone -3",count:67},{title:"Vechicle Dispatch",entityName:"Zone -5",count:667}]},
    //   {title:"fuel Amount",data:[{title:"fuel Amount",entityName:"Zone -1",count:67},{title:"fuel Amount",entityName:"Zone -2",count:677},{title:"fuel Amount",entityName:"Zone -3",count:67},{title:"fuel Amount",entityName:"Zone -5",count:667}]},
    //   {title:"Attendance",data:[{title:"Attendance",entityName:"Zone -1",count:67},{title:"Attendance",entityName:"Zone -2",count:677},{title:"Attendance",entityName:"Zone -3",count:67},{title:"Attendance",entityName:"Zone -5",count:667}]},
    //   {title:"fuel Liters",data:[{title:"fuel Liters",entityName:"Zone -1",count:67},{title:"fuel Liters",entityName:"Zone -2",count:677},{title:"fuel Liters",entityName:"Zone -3",count:67},{title:"fuel Liters",entityName:"Zone -5",count:667}]},
    //   {title:"Maintenance Repaired",data:[{title:"Maintenance Repaired",entityName:"Zone -1",count:67},{title:"Maintenance Repaired",entityName:"Zone -2",count:677},{title:"Maintenance Repaired",entityName:"Zone -3",count:67},{title:"Maintenance Repaired",entityName:"Zone -5",count:667}]},
    //   {title:"Maintenance Damaged",data:[{title:"Maintenance Damaged",entityName:"Zone -1",count:67},{title:"Maintenance Damaged",entityName:"Zone -2",count:677},{title:"Maintenance Damaged",entityName:"Zone -3",count:67},{title:"Maintenance Damaged",entityName:"Zone -5",count:667}]}
    // ]

    this.monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var d = new Date()
    this.month = d.getMonth() ;
    this.year = d.getFullYear();
    this.monthName = this.monthArray[this.month - 1]
    this.loaderService.status.subscribe((val: boolean) =>{
      this.showLoader = val;
    }); 
    this.totalHHCount=0;
    this.precentage=0;
    this.totalCurrentMonthTargt=0;
   }

   navigateMonth(move){
    this.loaderService.display(true);
     if(move == "prev"){
       this.month = this.month -1
      this.monthName = this.monthArray[this.month - 1]
      if(this.month<=0){
        this.month = 11
        this.monthName = [this.monthArray[this.month ]]
        this.year = this.year - 1
      }
      this.getTargetDataPrev(this.month ,this.year,"achieved");
     }else{
      this.month  = this.month + 1
      this.monthName = this.monthArray[this.month-1]
      if(this.month > 12){
        this.month = 0
        this.monthName = [this.monthArray[this.month]]
        this.year = this.year + 1
      }
      this.getTargetDataPrev(this.month ,this.year,"achieved");
     }
     setTimeout(() =>{ this.loaderService.display(false); },1000); 
   }

   getAcheivedDataCurrent(month,year,type){
    this.http.get(environment.apiUrl + "entity/getEntityTarget?prjId="+ this.prjId + "&month=" + month + "&year="  + year + "&type=" + type ).subscribe(data => {
      this.acheivedDataArrayCurrent = data 
      console.log(this.targetDataArray)
      this.http.get(environment.apiUrl + "entity/getTargetCategory?prjId="+ this.prjId).subscribe(data => {
        this.targetCategory = data 
        this.bindTargetDataCurrent()        
      })
    })
   }


  

   dataPriv:any;
   bindDataPrev(){
    this.targetDataPrev = []
     for(var i=0;i<this.targetCategory.length;i++){
       var category = this.targetCategory[i].category
       var data = [] 
       this.dataPriv=0;
      for(var j=0;j<this.targetDataArrayPrev.length;j++){
          if(category == this.targetDataArrayPrev[j].title){
          data.push(this.targetDataArrayPrev[j])
          this.dataPriv=this.dataPriv+this.targetDataArrayPrev[j].data
        }}
      this.targetDataPrev.push({data:data}) 
      this.targetDataPrev[i].data.push({entityName:"Total",data:this.dataPriv.toFixed(2)})
     }
   }

   /*
    * BIND CURRENT MONTH TARGET DATA
   */ 
   bindTargetDataCurrent(){
    this.acheivedDataCurrent = []
    this.totalCurrentMonthTargt=0;
    for(var i=0;i<this.targetCategory.length;i++){
      var category = this.targetCategory[i].category
      var data = []
     for(var j=0;j<this.acheivedDataArrayCurrent.length;j++){
         if(category == this.acheivedDataArrayCurrent[j].title){
           data.push(this.acheivedDataArrayCurrent[j])
           this.totalCurrentMonthTargt=this.totalCurrentMonthTargt+this.acheivedDataArrayCurrent[j].data
           //console.log("current Month Target Data--",this.acheivedDataArrayCurrent[j].data)  
       }
     }
     this.acheivedDataCurrent.push({data:data}) 
     this.acheivedDataCurrent[i].data.push({entityName:"Total",data:this.totalCurrentMonthTargt.toFixed(2)})
     this.totalCurrentMonthTargt=0;
    }  
   }

   /*
    * BIND CURRENT MONTH ACHIVED DATA
   */  
   bindDataCurrent(){
    this.targetDataCurrent = [] 
    this.precentage=0;
    this.totalHHCount=0;
     for(var i=0;i<this.targetCategory.length;i++){
       var category = this.targetCategory[i].category
       var data = []
       for(var j=0;j<this.targetDataArrayCurrent.length;j++){
          if(category == this.targetDataArrayCurrent[j].title){
            this.targetDataArrayCurrent[j].precentage = this.targetDataArrayCurrent[j].achievedPercentage+'%'
            data.push(this.targetDataArrayCurrent[j])  
            this.totalHHCount=this.totalHHCount+this.targetDataArrayCurrent[j].data  
        } 
      } 
      this.targetDataCurrent.push({data:data})  
      this.targetDataCurrent[i].data.push({entityName:"Total",data:this.totalHHCount.toFixed(2)}) 
      this.totalHHCount=0;
     } 
   }
  
   getTargetDataPrev(month,year,type){
    this.http.get(environment.apiUrl + "entity/getEntityTarget?prjId="+ this.prjId + "&month=" + month + "&year="  + year + "&type=" + type ).subscribe(data => {
      this.targetDataArrayPrev = data 
      this.http.get(environment.apiUrl + "entity/getTargetCategory?prjId="+ this.prjId).subscribe(data => {
        this.targetCategory = data 
        this.bindDataPrev()        
      })
    })
  }

  getTargetDataCurrent(month,year,type){
    this.http.get(environment.apiUrl + "entity/getEntityTarget?prjId="+ this.prjId + "&month=" + month + "&year="  + year + "&type=" + type ).subscribe(data => {
      this.targetDataArrayCurrent = data   
        this.http.get(environment.apiUrl + "entity/getTargetCategory?prjId="+ this.prjId).subscribe(data => {
        this.targetCategory = data 
        this.bindDataCurrent()  
      })
    })
  }

   getTargetEntityName(){
    this.http.get(environment.apiUrl + "entity/getTargetEntityByOrder?prjId="+ this.prjId).subscribe(data => {
      this.zoneData = data 
    })
   }
   target_toggle(){ 
     $('.Target_hide').toggle();
   }
   getTargetCategory(){
    this.http.get(environment.apiUrl + "entity/getTargetCategory?prjId="+ this.prjId).subscribe(data => {
      this.targetCategory = data 
      console.log("targetCategory",this.targetCategory)      
    })
   }
   ngOnInit(): void { 
     this.prjId = this.auth.getAuthentication().projectId 
     this.loaderService.display(true); 
     this.getTargetDataPrev(this.month -1,this.year,"achieved"); 
     this.getTargetDataCurrent(this.month,this.year,"achieved");
     this.getAcheivedDataCurrent(this.month,this.year,"target"); 
     setTimeout(() =>{ this.loaderService.display(false); },1000); 
     //this.getTargetEntityName()
    // this.getTargetCategory()
  }


}













// WEBPACK FOOTER //
// ./src/app/dashboard/target/targetDashboard.component.ts